export default __webpack_public_path__ + "static/logo-411911251c103f7e3b24b2a1858f0752.png";